// @mui
import Box, { type BoxProps } from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

// ----------------------------------------------------------------------

export default function LoadingScreen ({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        px: 5,
        width: 1,
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx
      }}
      {...other}
    >
      <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%', color: '#3863ff' }} />
    </Box>
  )
}
